<template>
  <div class="invoiceList">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="120px"
        :model="formInline"
        inline
      >
        <el-form-item prop="nickeName" label="学员昵称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.nickeName"
            placeholder="请输入学员昵称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="学员手机号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.phone"
            placeholder="请输入学员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="status" label="开票状态">
          <el-select
            style="width: 290px"
            v-model="formInline.status"
            placeholder="请选择开票状态"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="已开票" value="2"></el-option>
            <el-option label="未开票" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="invoiceCategory" label="发票类目">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.invoiceCategory"
            placeholder="请输入发票类目"
          ></el-input>
        </el-form-item> -->
        <el-form-item prop="queryTime" label="申请时间">
          <my-datePicker
            width="290px"
            :scopeDate="formInline.queryTime"
            @receiveMyDate="receiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="invoiceTitle" label="发票类型">
          <el-select
            style="width: 290px"
            v-model="formInline.invoiceTitle"
            placeholder="请选择开票状态"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="个人" value="1"></el-option>
            <el-option label="企业" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="invoiceCustName" label="发票抬头名称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.invoiceCustName"
            placeholder="请输入发票抬头名称"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="checkAdmin()" prop="companyId" label="所属公司">
          <el-select
            style="width: 290px"
            v-model="formInline.companyId"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="学员昵称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickeName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="170" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="发票类型" minWidth="130" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.invoiceTitle === 1">个人</el-tag>
            <el-tag type="success" v-else-if="row.invoiceTitle === 2">企业</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="发票抬头名称" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.invoiceCustName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票类目" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.invoiceCategory || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票状态" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 2">已开票</el-tag>
            <el-tag type="danger" v-else-if="row.status === 1">未开票</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="发票申请日期" width="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属公司" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单信息" width="160" align="center">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openOrderDetail(row)">查看订单信息</span>
          </template>
        </el-table-column>
        <el-table-column width="210" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openLookInvoiceInfo(row)">查看发票信息</span>
            <span
              class="blue_Box"
              v-if="row.invoiceUrl"
              @click="lookInvoice(row)"
            >查看发票</span            >
            <span class="blue_Box" v-else @click="openUploadInvoice(row)">上传发票</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 订单详情 -->
    <OrderDetail ref="orderDetailRef" />
    <!-- 查看发票信息 -->
    <LookInvoiceInfo ref="lookInvoiceInfoRef" />
    <!-- 上传发票 -->
    <UploadInvoice ref="uploadInvoiceRef" />
  </div>
</template>

<script>
import { getInvoiceListPage } from "@/api/orderAdmin/invoiceList.js";
import OrderDetail from "@/views/orderAdmin/components/orderDetail.vue";
import UploadInvoice from "@/views/orderAdmin/components/uploadInvoice.vue";
import LookInvoiceInfo from "@/views/orderAdmin/components/lookInvoiceInfo.vue";
import myPagination from "@/components/myPagination.vue";
import myDatePicker from "@/components/myDatePicker.vue";
import { clone, processing } from "@/utils/handle.js"
import { getSelectCompanyList } from "@/api/orderAdmin/orderList";;
import { getAppUserInfo } from "@/api/common";
export default {
  name: "InvoiceList",
  components: {
    myPagination,
    myDatePicker,
    LookInvoiceInfo,
    OrderDetail,
    UploadInvoice,
  },
  data() {
    return {
      loading: false,
      formInline: {
        nickeName: "",
        phone: "",
        status: "-1",
        queryTime: [],
        queryStartTime: "",
        queryEndTime: "",
        invoiceTitle: "-1",
        companyId: '-1',
        invoiceCompany: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      companyData: []
    };
  },
  mounted() {
    // this.getInvoiceListPage({ page: 1, limit: 10 });
    this.getSelectCompanyList()
  },
  methods: {
    // 查看发票
    lookInvoice(payload) {
      window.open(payload.invoiceUrl);
    },
    // 上传发票
    openUploadInvoice(payload) {
      this.$refs.uploadInvoiceRef.init(payload);
    },
    // 订单详情
    openOrderDetail(payload) {
      this.$refs.orderDetailRef.init(payload.orderId);
    },
    // 查看发票信息
    openLookInvoiceInfo(payload) {
      this.$refs.lookInvoiceInfoRef.init(payload);
    },
    receiveMyDate(payload) {
      this.formInline.queryTime = payload;
      this.formInline.queryStartTime = payload[0] + " 00:00:00";
      this.formInline.queryEndTime = payload[1] + " 23:59:59";
    },
    // 刷新
    refresh() {
      this.getInvoiceListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getInvoiceListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.queryTime;
      const res = await getInvoiceListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getInvoiceListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.formInline.queryTime = [];
      this.formInline.queryStartTime = "";
      this.formInline.queryEndTime = "";
      this.$refs["formInline"].resetFields();
      this.getSelectCompanyList();
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getInvoiceListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 租户列表
    async getSelectCompanyList() {
      if (!this.checkAdmin()) {
        this.formInline.companyId = this.$myStore.state.user.userInfo.companyId
        this.searchData.companyId = this.$myStore.state.user.userInfo.companyId
      } else {
        const res = await getSelectCompanyList()
        if(res.code === 0){
          this.companyData = res.data || [];
          this.formInline.companyId = res.data[0]?.id;
          this.searchData.companyId = res.data[0]?.id;
        }
      }
      this.getInvoiceListPage({
        page: 1,
        limit: 10,
        companyId: this.formInline.companyId,
      })
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getInvoiceListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.invoiceList {
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
